"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _googleLibphonenumber = require("google-libphonenumber");
var getFormatPhone = function getFormatPhone(phone) {
  if (!phone) {
    return '';
  }
  var phoneUtil = _googleLibphonenumber.PhoneNumberUtil.getInstance();
  var phoneNumber = phoneUtil.parseAndKeepRawInput(phone, 'US');
  return phoneUtil.formatInOriginalFormat(phoneNumber, 'US');
};
var _default = getFormatPhone;
exports.default = _default;